// @ts-check

if (!customElements.get("ff-tab-panels")) {
  class FfTabPanels extends HTMLElement {
    /**
     * @type {"own_close" | "own_expand" | "else" | undefined}
     */
    ffTransition;
    /**
     * @type {undefined | function}
     */
    ffWaitingAction;

    /**
     * @type {{tabTriggerEL: undefined | HTMLElement & {ffOnClick: () => void}, tabContentEL: undefined | HTMLElement}}
     */
    ffActive = {
      tabTriggerEL: undefined,
      tabContentEL: undefined,
    };

    constructor() {
      super();
      this.ffInit();
    }

    ffInit = () => {
      // Mover bloques _ff-facets fuera de ff-tab-panels
      const facetsBlocks = this.querySelectorAll('.ff-theme-block_facets');
      facetsBlocks.forEach((facetBlock) => {
        this.parentElement.insertBefore(facetBlock, this);
      });

      const tabsEL = [];
      /**
       * @type {HTMLElement[]}
       */
      const tabsContentEL = [];
      /**
       * @type {HTMLElement[]}
       */
      const tabsTriggersEL = [];

      // Create ResizeObserver to watch for height changes
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const target = entry.target;
          if (target.classList.contains("ff-tab-panel-active")) {
            const newHeight = target.clientHeight;
            this.style.setProperty("--ff-grid-height", newHeight + 1 + "px");
          }
        }
      });

      // Store the ResizeObserver for cleanup
      this.resizeObserver = resizeObserver;

      // @ts-ignore
      this.querySelectorAll(
        '[data-ff-tab-panels="' + this.id + '"]'
      ).forEach((tabTriggerEL) => {
        const { ffTabPanelContentSelector, ffTabPanelInitActive } =
          tabTriggerEL.dataset;
        const tabContentEL = this.querySelector(
          ffTabPanelContentSelector
        );
        // @ts-ignore
        tabsTriggersEL.push(tabTriggerEL);
        // @ts-ignore
        tabsContentEL.push(tabContentEL);

        // Observe each tab content element for height changes
        if (tabContentEL) {
          resizeObserver.observe(tabContentEL);
        }

        if (ffTabPanelInitActive) {
          this.ffActive = {
            tabTriggerEL,
            tabContentEL,
          };
        }
      });

      tabsEL.push(...tabsContentEL, ...tabsTriggersEL);

      for (let index = 0; tabsTriggersEL.length > index; index++) {
        const tabContentEL = tabsContentEL[index];
        /**
         * @type {HTMLElement & {ffOnClick: () => void}}
         */
        // @ts-ignore
        const tabTriggerEL = tabsTriggersEL[index];

        tabTriggerEL.ffOnClick = () => {
          for (let tabEl of tabsEL) {
            if (tabEl === tabTriggerEL) {
              continue;
            }
            if (tabEl === tabContentEL) {
              continue;
            }
            tabEl.classList.remove("ff-tab-panel-active");
          }

          tabTriggerEL.classList.toggle("ff-tab-panel-active");
          tabContentEL.classList.toggle("ff-tab-panel-active");
          tabTriggerEL.classList.add("ff-tab-panel_transitioning");

          // Update height for the new active tab
          if (tabContentEL.classList.contains("ff-tab-panel-active")) {
            this.style.setProperty(
              "--ff-grid-height",
              tabContentEL.clientHeight + 1 + "px"
            );
          }
          
          // Dispatch custom event when tab changes (always)
          document.dispatchEvent(new Event('ff-tab-changed'));

          if (this.ffActive.tabTriggerEL === tabTriggerEL) {
            this.ffTransition = "own_close";
          } else if (this.ffActive.tabTriggerEL === undefined) {
            this.ffTransition = "own_expand";
          } else {
            this.ffTransition = "else";
          }

          this.ffActive = {
            tabTriggerEL,
            tabContentEL,
          };
        };

        tabTriggerEL.addEventListener("click", (e) => {
          if (this.ffWaitingAction === undefined) {
            switch (this.ffTransition) {
              case "own_close":
                if (this.ffActive.tabTriggerEL != tabTriggerEL) {
                  this.ffWaitingAction = tabTriggerEL.ffOnClick;
                }
                break;

              case "own_expand":
                this.ffWaitingAction = () => {
                  this.ffActive.tabTriggerEL?.ffOnClick();
                  this.ffWaitingAction = tabTriggerEL.ffOnClick;
                };
                break;

              case "else":
                this.ffWaitingAction = tabTriggerEL.ffOnClick;
                break;

              default:
                if (
                  this.ffActive.tabTriggerEL &&
                  this.ffActive.tabTriggerEL != tabTriggerEL
                ) {
                  this.ffActive.tabTriggerEL.ffOnClick();
                  this.ffWaitingAction = tabTriggerEL.ffOnClick;
                } else {
                  tabTriggerEL.ffOnClick();
                }
                break;
            }
          }
        });

        tabContentEL.addEventListener("transitionend", () => {
          tabTriggerEL.classList.remove("ff-tab-panel_transitioning");

          if (this.ffTransition == "own_close") {
            this.ffActive = {
              tabTriggerEL: undefined,
              tabContentEL: undefined,
            };
          }

          if (this.ffWaitingAction) {
            //action has the ability to stablish a waiting action
            const action = this.ffWaitingAction;
            this.ffWaitingAction = undefined;
            action();
          } else {
            this.ffTransition = undefined;
          }
        });
      }

      if (!this.ffActive.tabContentEL) {
        this.ffActive = {
          tabTriggerEL: tabsTriggersEL[0],
          tabContentEL: tabsContentEL[0],
        };
        tabsTriggersEL[0].classList.add("ff-tab-panel-active");
        tabsContentEL[0].classList.add("ff-tab-panel-active");
      }

      // Calculate header height after layout is complete
      const calculateHeaderHeight = () => {
        const buttonElements = this.querySelectorAll(".ff-products-tab-button, .ff-products-tabs-title");
        
        if (buttonElements.length === 0) return 0;

        // Get the container's top position
        const containerRect = this.getBoundingClientRect();
        const containerTop = containerRect.top;

        // Find the bottommost button position
        let maxBottom = containerTop;
        buttonElements.forEach((el) => {
          const rect = el.getBoundingClientRect();
          if (rect.bottom > maxBottom) {
            maxBottom = rect.bottom;
          }
        });

        // Calculate height from container top to bottom of last button
        const calculatedHeight = maxBottom - containerTop;
        
        // Return calculated height, ensuring a minimum reasonable value
        return Math.max(calculatedHeight, 0);
      };

      // Function to update header height
      const updateHeaderHeight = () => {
        requestAnimationFrame(() => {
          const headerHeight = calculateHeaderHeight();
          this.style.setProperty("--ff-header-height", headerHeight + "px");
        });
      };

      // Initial calculation after layout stabilizes
      updateHeaderHeight();

      // Recalculate on window resize (for device rotation or viewport changes)
      const resizeHandler = () => {
        updateHeaderHeight();
      };
      window.addEventListener("resize", resizeHandler);
      
      // Store handler for cleanup
      this.resizeHandler = resizeHandler;

      const tabContentHeight = this.ffActive.tabContentEL.clientHeight;
      this.style.setProperty("--ff-grid-height", tabContentHeight + 1 + "px");

      requestAnimationFrame(() => {
        this.classList.remove("ff-tab-panels-not-initialized--js");
      });
    };

    // Cleanup method to disconnect ResizeObserver and resize handler
    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.resizeHandler) {
        window.removeEventListener("resize", this.resizeHandler);
      }
    }
  }

  customElements.define("ff-tab-panels", FfTabPanels);
}

// @ts-ignore
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    requestAnimationFrame(() => {
      /**
       * @type {NodeListOf<HTMLElement>}
       */
      const navigators = document.querySelectorAll("ff-tab-panels");
      navigators.forEach((tabs) => {
        // @ts-ignore
        tabs.ffInit();
      });
    });
  });
}

